export default {
  documentTitle: 'KeyPal硬件錢包-守護你的數字資產',
  product: '產品',
  learn: '學習',
  support: '支援',
  others: '其他',
  language: '語言',
  forBusiness: '商務合作',
  apps: '應用',
  secretBox: 'Secret Box',
  learnMore: '了解更多', 
  goShoppingCart: '前往商城', 
  contactUs: '聯絡我們:', 
  tutorials: '教程', 
  mobileWallet: '手機錢包', 
  extensionWallet: '插件錢包', 
  cases: '案例:', 
  cooperationSolution: '合作方案', 
  information: '資訊', 
  security: '安全', 
  darkMode: '暗黑模式',
  KeyPal_2_firmware: 'KeyPal 2 韌體', 
  KeyPal_Plus_firmware: 'KeyPal Plus 韌體',
  more: '及更多。',
  comingSoon: '敬请期待',
}
